<section class="ao-block" *ngIf="isPortfolioCif7">
  <header class="ao-header">
    <div class="row">
      <div class="col-sm-7">
        <h2 class="ao-header-title text-overflow">
          <i class="icon-credit-card"></i>
          <span
            class="credit-card-title"
            *scText="rendering.fields.title"
          ></span>
        </h2>
      </div>
    </div>
  </header>
  <div class="table-responsive">
    <table class="table table-striped ao-table">
      <colgroup class="row">
        <col class="col-sm-3" />
        <col class="col-sm-3" />
        <col class="col-sm-1" />
        <col class="col-sm-2" />
        <col class="col-sm-1" />
        <col class="col-sm-1" />
        <col class="col-sm-1" />
      </colgroup>
      <thead>
        <tr>
          <th
            [ngClass]="item.fields.css.value"
            *ngFor="let item of rendering.fields.items"
          >
            <span *scText="item.fields.label"></span>
            <i
              *ngIf="item.fields.hint.value"
              class="icon-info-circle tooltip-icon"
              matTooltipClass="info-tooltip"
              [matTooltip]="item.fields.hint.value"
            ></i>
          </th>
        </tr>
      </thead>
      <tbody>
        <div class="loader-bar" *ngIf="isLoading"></div>
        <ng-container *ngFor="let card of cards">
          <tr>
            <td class="card-number">
              <a
                [routerLink]="rendering.fields.transactionsPage.value.href"
                [queryParams]="{ id: card.id }"
                >{{ card.suffix }}</a
              >
            </td>
            <td class="card-name">
              {{ card.name }}
              <small
                class="text-muted"
                *ngIf="card.status !== CreditCardStatus.ACTIVE"
              >
                ({{ creditCardStatusMap[card.status] }})
              </small>
            </td>
            <td class="text-center">{{ card.limit.currencyCode }}</td>
            <td class="text-right">
              {{ card.limit.amount | currency: '':'' }}
            </td>
            <td class="text-right">
              {{ card.balance.amount | currency: '':'' }}
            </td>
            <td class="text-right">
              {{ card.availableCredit.amount | currency: '':'' }}
            </td>
            <td class="text-right status">
              <button
                type="button"
                [disabled]="card.status === CreditCardStatus.BLOCKED"
                class="btn btn-icon-square btn-primary pointer-events-none"
                (click)="changeStatus(card)"
              >
                <i class="icon-credit-card "></i>
              </button>
            </td>
          </tr>
        </ng-container>
        <ng-container *ngIf="rendering.fields.emptyLabel">
          <tr *ngIf="cards.length === 0">
            <td class="text-center" colspan="7">
              <span
                class="badge badge-warning"
                *scText="rendering.fields.emptyLabel"
              ></span>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</section>

<!--
  If IA start return other statuses 'ngClass' can be used for style the button with correct colors
  [ngClass]="{
  'btn-primary': card.status === CreditCardStatus.ACTIVE,
  'btn-disabled': card.status === CreditCardStatus.BLOCKED,
  'btn-danger-2 unlinked':
    card.status === CreditCardStatus.UNLINKED
}" -->
